import { makeStyles } from "tss-react/mui";

const useOutlinedAutocompleteStyles = makeStyles()((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      color: theme.palette.text.primary,
    },
  },
  whiteFilled: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.surface.light,
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      "& fieldset": {
        borderColor: theme.palette.strokes.defaultGrey,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.strokes.defaultGrey,
      },
      "&.Mui-focused": {
        backgroundColor: theme.palette.surface.light,
        boxShadow: "none",
        "& fieldset": {
          borderColor: theme.palette.strokes.defaultGrey,
        },
      },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.surface.light,
      },
    },
  },
  renderOpDiv: {
    maxWidth: "100%",
    height: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  noWrap: {
    whiteSpace: "noWrap",
  },
}));

export default useOutlinedAutocompleteStyles;
